import { createContext, useContext, useState, useEffect } from 'react';

export type League = 'mlb' | 'nba' | 'nhl' | 'nfl';
export type Day = 'yesterday' | 'today' | 'tomorrow';

const LeagueContext = createContext<{
  league: League;
  setLeague: (league: League) => void;
  day: Day;
  setDay: (day: Day) => void;
}>({
  league: 'mlb',
  setLeague: () => {},
  day: 'today',
  setDay: () => {},
});

const VALID_LEAGUES: League[] = ['mlb', 'nba', 'nhl', 'nfl'];

export const LeagueProvider = ({ children }: { children: React.ReactNode }) => {
  const [league, setLeagueState] = useState<League>('mlb');
  const [day, setDay] = useState<Day>('today');

  useEffect(() => {
    const savedLeague = localStorage.getItem('selectedLeague') as League | null;
    if (savedLeague && VALID_LEAGUES.includes(savedLeague)) {
      setLeagueState(savedLeague);
    } else {
      // Always set to 'mlb' if nothing saved yet
      localStorage.setItem('selectedLeague', 'mlb');
      setLeagueState('mlb');
    }
  }, []);

  const setLeague = (newLeague: League) => {
    setLeagueState(newLeague);
    localStorage.setItem('selectedLeague', newLeague);
  };

  return (
    <LeagueContext.Provider value={{ league, setLeague, day, setDay }}>
      {children}
    </LeagueContext.Provider>
  );
};

export const useLeague = () => useContext(LeagueContext);
